// extracted by mini-css-extract-plugin
export default {"split":"UnitsCenter_split__vIW66","narrowInput":"UnitsCenter_narrowInput__RIGyG"};